import { HttpAuth } from "../../config/Http"
import { changeLoading } from "./loading.action"
import { changeNotify } from "./notify.action"

export const actionTypes = {
    CHANGE: 'SMS_CHANGE',
    SUCCESS: 'SMS_SUCCESS',
    ERROR: 'SMS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const setError = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

/* VALIDATE CODE */

export const validateCode = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Validando código...'
    }))

    return HttpAuth.post('/2fa/verification-code', data)
        .then(res => dispatch(changeLoading({open: false,msg: 'Carregando...'})) && res.data)
        .catch(error => {
            dispatch(changeLoading({
                open: false,
                msg: 'Carregando...'
            }))

            if(error.response) {
                if(error.response.status === 400) {
                    if(typeof error.response.data.code !== undefined) {
                        dispatch(setError(error.response.data))
                    }

                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }

                    if(typeof error.response.data.msg !== undefined) {
                        dispatch( changeNotify({
                            open: true,
                            class: error.response.data.class,
                            msg: error.response.data.msg
                        }))
                    }
                } 
            }
        })
}

/* SEND CODE */

export const sendCode = (method, capitalizer = false) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Enviando código...'
    }))

    return HttpAuth.post('/2fa/send/'+method, {
        capitalizer: capitalizer
    })
        .then(res => dispatch(changeLoading({open: false,msg: 'Carregando...'})) && res.data)
        .catch(error => {
            dispatch(changeLoading({
                open: false,
                msg: 'Carregando...'
            }))

            if(error.response) {
                if(error.response.status === 400) {
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }

                    if(typeof error.response.data.msg !== undefined) {
                        dispatch( changeNotify({
                            open: true,
                            class: error.response.data.class,
                            msg: error.response.data.msg
                        }))
                    }
                } 
            }
        })
}

